import React, { useContext, useEffect, useRef, useState } from "react";
//@mui
import { Box, CircularProgress, Grid2 } from "@mui/material";
//styling
import signupStyles from "./Signup.module.scss";
// Icons
import { ReactComponent as Usa } from "../../../../GlobalAssets/svg/UsaSvg.svg";
import { ReactComponent as Indian } from "../../../../GlobalAssets/svg/IndianSvg.svg";
//Local import
import CustomInput from "../../../../GlobalComponents/CustomInput/CustomInput";
import Dropdown from "../../../../GlobalComponents/Dropdown/Dropdown";
import {
  verifyEmail,
  verifyLength,
  verifyPassword,
  verifyPhoneNumber,
} from "../../../../Utils/utils";
import classNames from "classnames";
import { useLocation, useNavigate } from "react-router-dom";
import CongnitoServices from "../../../../redux/Services/cognitoServices";
import ReCAPTCHA from "react-google-recaptcha";
import CustomStepper from "../../../../GlobalComponents/CustomStepper/CustomStepper";
import zipcodes from "zipcodes";
import { resendSignUpCode } from "aws-amplify/auth";
// import PhoneInput from "react-phone-input-2";
import "react-phone-input-2/lib/bootstrap.css";
import { countryStateData } from "../../../../Utils/countryStateData";
import ConfigureContext from "../../../../store/ConfigureContext";
import axios from "axios";

// const phoneInputStyle = {
//   width: "100%",
//   fontSize: "16px",
//   background: "rgb(255, 255, 255)",
//   border: "1px solid #dedede",
//   borderRadius: "7px",
//   outline: "none",
//   color: "rgb(73, 80, 87)",
//   transition: "box-shadow 0.25s, border-color 0.25s",
//   padding: "14px 14px 14px 60px",
// };

const countryOptions = [
  { label: "INDIA", value: "India", img: <Indian /> },
  { label: "USA", value: "USA", img: <Usa /> },
];

const recaptchaStatus = process.env.REACT_APP_RECAPTCHA_LOGIN;
const recaptchSiteKey = process.env.REACT_APP_RECAPTCHA_SITE_KEY;

export default function NewSignup() {
  // Props and Hooks
  const location = useLocation();
  const { cognitoId } = useContext(ConfigureContext);

  const [loading, setLoading] = useState(false);
  const [hasSubmitted, setHasSubmitted] = useState(false);
  const [captchaToken, setCaptchaToken] = useState();
  const [enteredCode, setEnteredCode] = useState("");
  const navigate = useNavigate();
  const inputRefs = useRef([]);
  const [activeStep, setActiveStep] = useState(0);
  const [error, setError] = useState(false);

  const queryParams = new URLSearchParams(location.search);
  const emailId = queryParams.get("emailId");
  const orgId = queryParams.get("orgId");

  const [values, setValues] = useState({
    email: "" || emailId,
    emailState: "error",
    emailErrorMessage: "Email is required",

    name: "",
    nameState: "error",
    nameErrorMessage: "Name is Required",

    phoneNumber: "",
    phoneNumberState: "error",
    phoneNumberErrorMessage: "Please enter a valid phone number",

    password: "",
    passwordState: "error",
    passwordErrorMessage: "Password is Required",

    tos: false,
    country: "USA",

    states: countryStateData["USA"],
    state: "",
    stateState: "error",
    stateErrorMessage: "Please select state",

    zipCode: "",
    zipCodeState: "error",
    zipCodeErrorMessage: "Please enter a valid zip code",

    city: "",
    cityState: "error",
    cityErrorMessage: "Please enter a valid city",

    address: "",
    addressState: "error",
    addressErrorMessage: "Please enter a valid address",
  });

  const [inputErrorVar, setInputErrorVar] = useState({
    email: false,
    password: false,
    phoneNumber: false,
    name: false,
    tos: false,
    country: false,
    state: false,
    city: false,
    address: false,
    zipCode: false,
    captcha: false,
    recaptchaStatus: false,
  });

  useEffect(() => {
    try {
      axios
        .get(
          `${process.env.REACT_APP_BACK_END_API_BASE_URL}/users/isUserPartOfOrg?email=${emailId}&orgId=${orgId}`
        )
        .then((response) => {
          if (response.data === false) {
            window.location.href = "https://roconpaas.com/";
          }
        })
        .catch((error) => {
          console.error("Error fetching user org status:", error);
        });
    } catch (e) {
      console.error("Unexpected error:", e);
    }
  }, [orgId]);

  //metaData is a boolean value which can be used to add extraLogic
  const handleChange = (prop, type, value, length, metaData) => {
    let status = "";
    let message = "";
    switch (type) {
      case "email":
        setError(null);
        if (process.env.REACT_APP_TEMP_DOMAIN === "roconpaas.io") {
          // Remove plus symbol from email
          value = value.replace(/\+/g, "");
          value = value.replace(/\s/g, "");
        } else {
          value = value.replace(/\s/g, "");
        }
        if (verifyEmail(value)) {
          status = "success";
        } else {
          status = "error";
          message = "Please enter a valid email";
        }
        break;
      case "password":
        if (!verifyPassword(value)) {
          status = "error";
          setValues({
            ...values,
            password: value,
            passwordState: status,
            passwordErrorMessage: !verifyPassword(value)
              ? "Password should be 8 char long with upper & lower case, number and special char"
              : null,
          });
        } else {
          status = "success";
          setValues({
            ...values,
            password: value,
            passwordState: status,
          });
        }
        break;

      case "phoneNumber":
        status = verifyPhoneNumber(value, values.country) ? "success" : "error";
        if (values.country === "USA") {
          // Format for USA: (999) 999-9999
          value = PhoneNumberformat(value, "USA", metaData);
        } else if (values.country === "India") {
          // Format for India: 99999-99999
          value = PhoneNumberformat(value, "India", metaData);
        }
        break;

      case "length":
        if (verifyLength(value, length)) {
          status = "success";
        } else {
          status = "error";
          // error message specific to name
          message = "Please enter at least 3 characters.";
        }
        break;

      case "country":
        const filteredStates = countryStateData[value] || [];
        setValues({
          ...values,
          country: value,
          state: "",
          states: filteredStates,
        });
        break;

      case "state":
        value = value.replace(/[^a-zA-Z]/g, "");
        if (value.length > 3) {
          status = "success";
        } else {
          status = "error";
          message = "Please enter a valid state name";
        }
        break;

      case "zipCode":
        value = value.replace(/[^0-9]/g, "");
        if (value.length > 8) {
          value = value.slice(0, 8);
        }
        if (value.length > 4) {
          status = "success";
        } else {
          status = "error";
          message = "Please enter a valid zip code";
        }
        break;

      case "city":
        // Allow only letters and spaces for city
        value = value.replace(/[^a-zA-Z\s]/g, "");
        if (value.trim().length > 2) {
          status = "success";
        } else {
          status = "error";
          message = "Please enter a valid city";
        }
        break;

      case "address":
        // Allow common address characters
        value = value.replace(/[^a-zA-Z0-9\s,'\-\.\/\#]/g, "");
        if (value.trim().length > 5) {
          status = "success";
        } else {
          status = "error";
          message = "Please enter a valid address";
        }
        break;

      default:
        break;
    }
    if (!(prop === "password")) {
      setInputErrorVar({ ...inputErrorVar, [prop]: false });
      setValues({
        ...values,
        [prop + "State"]: status,
        [prop + "ErrorMessage"]: message,
        [prop]: value,
      });
    }
  };

  const PhoneNumberformat = (phoneNumber, country) => {
    // Remove all non-numeric characters
    const cleaned = phoneNumber.replace(/\D/g, "");

    if (country === "USA") {
      // Format for USA: (999) 999-9999
      if (cleaned.length <= 3) {
        return cleaned ? `(${cleaned}` : ""; // Remove `(` if empty
      } else if (cleaned.length <= 6) {
        return `(${cleaned.slice(0, 3)}) ${cleaned.slice(3)}`;
      } else if (cleaned.length <= 10) {
        return `(${cleaned.slice(0, 3)}) ${cleaned.slice(3, 6)}-${cleaned.slice(
          6
        )}`;
      } else {
        return `(${cleaned.slice(0, 3)}) ${cleaned.slice(3, 6)}-${cleaned.slice(
          6,
          10
        )}`;
      }
    } else if (country === "India") {
      // Format for India: 99999-99999
      if (cleaned.length <= 5) {
        return cleaned;
      } else if (cleaned.length <= 10) {
        return `${cleaned.slice(0, 5)}-${cleaned.slice(5)}`;
      } else {
        return `${cleaned.slice(0, 5)}-${cleaned.slice(5, 10)}`;
      }
    }

    return cleaned; // Fallback for other countries
  };

  const validateZipCode = (zipCode, country) => {
    if (!zipCode) return false;

    let isValid = false;

    if (country === "USA") {
      const zipData = zipcodes.lookup(zipCode);
      isValid = !!zipData;
    } else if (country === "India") {
      const indiaZipCodeRegex = /^[1-9]{1}[0-9]{5,7}$/;
      isValid = indiaZipCodeRegex.test(zipCode);
    }

    return isValid;
  };

  // Handle "Next" button click
  const submitHandler = async () => {
    setHasSubmitted(true);
    if (activeStep === 0) {
      if (
        (!emailId && values.emailState === "error") ||
        values.passwordState === "error" ||
        values.nameState === "error" ||
        !values.tos ||
        !captchaToken ||
        recaptchaStatus !== "true"
      ) {
        setInputErrorVar({
          email: !emailId && values.emailState === "error",
          password: values.passwordState === "error",
          name: values.nameState === "error",
          tos: !values.tos,
          captcha: !captchaToken,
          recaptchaStatus: recaptchaStatus !== "true",
        });
        return;
      }
      setLoading(true);
      try {
        setLoading(true);
        axios
          .get(
            `${
              process.env.REACT_APP_BACK_END_API_BASE_URL
            }/users/doesUserExists?userEmail=${encodeURIComponent(
              values.email || emailId
            )}&userPoolId=${cognitoId}`
          )
          .then((response) => {
            if (response.data === true) {
              setError("User already exists!");
            } else {
              window.grecaptcha.reset();
              setCaptchaToken(null);
              setActiveStep(1);
            }
            setLoading(false);
          })
          .catch((error) => {
            setLoading(false);
          });
      } catch (e) {
        setLoading(false);
      }
      return;
    }
    if (activeStep === 1) {
      const isZipValid = validateZipCode(values.zipCode, values.country);
      if (
        values.phoneNumberState === "error" ||
        values.country === "" ||
        values.state === "" ||
        values.stateState === "error" ||
        values.zipCodeState === "error" ||
        !isZipValid
      ) {
        setInputErrorVar({
          phoneNumber: values.phoneNumberState === "error",
          country: values.country === "",
          state: values.state === "" || values.stateState === "error",
          zipCode: values.zipCodeState === "error" || !isZipValid,
        });
        return;
      }
      setError(null);
      setLoading(true);
      try {
        const res = await CongnitoServices.signUpForm(values, captchaToken);
        setLoading(false);
        if (res === true) {
          setActiveStep(2);
        } else if (res) {
          setError(res);
        } else {
          setError("An unexpected error occurred. Please try again.");
        }
      } catch (error) {
        setLoading(false);
        setError("Failed to signup. Please try again.");
      }
      return;
    }
    if (activeStep === 2) {
      setError(null);
      setLoading(true);
      try {
        const cognitoResponse = await CongnitoServices.verifyEmail({
          email: values.email || emailId,
          verificationCode: enteredCode,
        });
        if (cognitoResponse) {
          const emailParam = encodeURIComponent(values.email || emailId || "");
          navigate(emailParam ? `/login?email=${emailParam}` : "/login");
        } else {
          setError("Verification failed. Please try again.");
        }
      } catch (e) {
        setError("An error occurred. Please try again.");
      } finally {
        setLoading(false);
      }
    }
  };

  function onChange(value) {
    setCaptchaToken(value);
    setError(null);
  }

  // Handle "Back" button click
  const handleBack = () => {
    if (activeStep === 2) {
      setActiveStep(1);
    } else if (activeStep === 1) {
      setActiveStep(0);
    }
  };

  const handleCodeKeyDown = (index, event) => {
    if (event.key === "Backspace" && !enteredCode[index] && index > 0) {
      inputRefs.current[index - 1].focus();
    } else if (event.key === "ArrowLeft" && index > 0) {
      inputRefs.current[index - 1].focus();
    } else if (event.key === "ArrowRight" && index < 5) {
      inputRefs.current[index + 1].focus();
    }
  };

  const handleCodeChange = (index, value) => {
    const updatedCode =
      enteredCode.slice(0, index) + value + enteredCode.slice(index + 1);
    setEnteredCode(updatedCode);
    setError(null);
    // Move to the next box automatically if a number is entered
    if (value && index < 5) {
      inputRefs.current[index + 1].focus();
    }
  };

  const handlePaste = (event) => {
    const pastedValue = event.clipboardData.getData("Text").replace(/\D/g, "");
    if (pastedValue.length === 6) {
      setEnteredCode(pastedValue);
      pastedValue.split("").forEach((char, index) => {
        if (inputRefs.current[index]) {
          inputRefs.current[index].value = char;
        }
      });
    }
  };

  const resendOtp = async () => {
    setLoading(true);
    try {
      await resendSignUpCode({ username: values.email || emailId });
      setEnteredCode("");
      inputRefs.current.forEach((input) => {
        if (input) input.value = "";
      });
      setError(null);
    } catch (e) {
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    const filteredStates = countryStateData[values.country] || [];
    setValues({
      ...values,
      states: filteredStates,
      state: "",
    });
  }, [values.country]);

  return (
    <>
      <Grid2 className={signupStyles.SignupContainer}>
        <Grid2 className={signupStyles.Header}>Sign Up</Grid2>
        <Grid2>
          <Grid2 className={signupStyles.subHeader}>Welcome to Rocon!</Grid2>
          <Grid2 className={signupStyles.subHeader1}>
            {activeStep === 2
              ? "Verify your email to activate your account"
              : "Complete the form below to get started."}
          </Grid2>
        </Grid2>
        <CustomStepper activeStep={activeStep} setActiveStep={setActiveStep} />

        {activeStep === 0 && (
          <>
            <Grid2 className={signupStyles.InputFlexbox}>
              <CustomInput
                placeholder="John Doe"
                required={true}
                value={values.name}
                error={inputErrorVar.name}
                errorMessage={values.nameErrorMessage}
                setValue={(value) => {
                  const cleanedValue = value.replace(/^\s+/, "");
                  handleChange("name", "length", cleanedValue, 3);
                }}
              />
              <CustomInput
                data-testid="signup-email"
                placeholder={"john@company.com"}
                required={true}
                error={inputErrorVar.email}
                errorMessage={values.emailErrorMessage}
                value={emailId || values.email}
                setValue={(value) => {
                  handleChange("email", "email", value.toLowerCase());
                }}
                disabled={emailId ? true : ""}
              />
              <Grid2>
                <CustomInput
                  data-testid="signup-password"
                  placeholder={"Password"}
                  password={true}
                  passwordview={true}
                  required={true}
                  error={
                    hasSubmitted
                      ? values.passwordState === "error"
                      : inputErrorVar.password
                  }
                  errorMessage={values.passwordErrorMessage}
                  value={values.password}
                  setValue={(value) => {
                    const cleanedValue = value.replace(/^\s+/, "");
                    handleChange("password", "password", cleanedValue);
                  }}
                />
                <Grid2 className={signupStyles.error}>{error}</Grid2>
              </Grid2>
              <Grid2 className={signupStyles.TermsFlexbox}>
                <input
                  data-testid="signup-check"
                  type="checkbox"
                  checked={values.tos}
                  onChange={() => setValues({ ...values, tos: !values.tos })}
                  className={classNames({
                    [signupStyles.errorCheckbox]:
                      inputErrorVar.tos && !values.tos,
                  })}
                />
                <Grid2>I agree with the</Grid2>
                <a
                  target="_blank"
                  href="https://roconpaas.com/terms-of-service/"
                  rel="noopener noreferrer"
                >
                  <Grid2 className={signupStyles.Terms}>Terms of Service</Grid2>
                </a>
                <Grid2>and</Grid2>
                <a
                  target="_blank"
                  href="https://roconpaas.com/privacy-policy/"
                  rel="noopener noreferrer"
                >
                  <Grid2 className={signupStyles.Terms}>Privacy Policy</Grid2>
                </a>
              </Grid2>
              {recaptchaStatus === "true" && (
                <Grid2 className={signupStyles.recaptch}>
                  <ReCAPTCHA sitekey={recaptchSiteKey} onChange={onChange} />
                </Grid2>
              )}
            </Grid2>
          </>
        )}

        {activeStep === 1 && (
          <>
            <Grid2 className={signupStyles.InputFlexbox}>
              <Dropdown
                options={countryOptions}
                placeholder={"Country"}
                value={values.country}
                onSelect={(value) => {
                  handleChange("country", "country", value);
                }}
                optlabel={"label"}
                optvalue={"value"}
                dropdownHeader={signupStyles.dropdownList}
              />
              {/* <PhoneInput
                placeholder="Enter your phone number"
                country={"us"}
                onlyCountries={["us", "in"]}
                enableSearch={false}
                error={inputErrorVar.phoneNumber}
                errorMessage={values.phoneNumberErrorMessage}
                value={values.phoneNumber}
                inputStyle={phoneInputStyle}
                onChange={(value) => {
                  handleChange("phoneNumber", "phoneNumber", value, 10, false);
                }}
              /> */}
              <Dropdown
                key={values.country}
                options={values.states}
                placeholder="Select State"
                value={values.state}
                error={inputErrorVar.state}
                errorMessage={values.stateErrorMessage}
                onSelect={(value) => {
                  handleChange("state", "state", value);
                }}
                optlabel={"label"}
                optvalue={"value"}
                dropdownHeader={signupStyles.dropdownList}
              />
              <CustomInput
                placeholder={"Enter City Name"}
                value={values.city}
                error={inputErrorVar.city}
                errorMessage={values.cityErrorMessage}
                setValue={(e) => {
                  handleChange("city", "city", e);
                }}
              />
              <CustomInput
                placeholder={"Enter Address"}
                value={values.address}
                error={inputErrorVar.address}
                errorMessage={values.addressErrorMessage}
                setValue={(e) => {
                  handleChange("address", "address", e);
                }}
              />
              <CustomInput
                placeholder="Enter Zip Code"
                data-testid="zip-code"
                required={true}
                value={values.zipCode}
                error={inputErrorVar.zipCode}
                errorMessage={values.zipCodeErrorMessage}
                setValue={(value) => {
                  handleChange("zipCode", "zipCode", value);
                }}
              />
              <Grid2>
                <CustomInput
                  placeholder={
                    values.country === "USA" ? "(999) 999-9999" : "99999-99999"
                  }
                  required={true}
                  error={inputErrorVar.phoneNumber}
                  errorMessage={values.phoneNumberErrorMessage}
                  value={PhoneNumberformat(values.phoneNumber, values.country)}
                  setValue={(value, _, event) => {
                    if (
                      event.nativeEvent.inputType === "deleteContentBackward"
                    ) {
                      // Handle backspace
                      if (values.country === "USA") {
                        if (value.endsWith(") ")) {
                          value = value.substring(0, value.length - 2); // Remove ') ' characters
                        } else if (value.endsWith("-")) {
                          value = value.substring(0, value.length - 1); // Remove '-' character
                        }
                      } else if (values.country === "India") {
                        if (value.endsWith("-")) {
                          value = value.substring(0, value.length - 1); // Remove '-' character
                        }
                      }
                    } else {
                      value = value.replace(/\D/g, ""); // Allow only numeric characters
                      if (values.country === "USA") {
                        if (value.length > 10) {
                          value = value.substring(0, 10); // Limit to 10 characters
                        }
                        if (value.length >= 1) {
                          value = "(" + value;
                        }
                        if (value.length >= 4) {
                          value =
                            value.substring(0, 4) + ") " + value.substring(4);
                        }
                        if (value.length >= 9) {
                          value =
                            value.substring(0, 9) + "-" + value.substring(9);
                        }
                      } else if (values.country === "India") {
                        if (value.length > 10) {
                          value = value.substring(0, 10); // Limit to 10 characters
                        }
                        if (value.length >= 6) {
                          value =
                            value.substring(0, 5) + "-" + value.substring(5);
                        }
                      }
                    }
                    handleChange(
                      "phoneNumber",
                      "phoneNumber",
                      value,
                      10,
                      false
                    );
                  }}
                />
                <Grid2 className={signupStyles.error}>{error}</Grid2>
              </Grid2>
            </Grid2>
          </>
        )}

        {activeStep === 2 && (
          <>
            <Grid2 className={signupStyles.verification}>
              Please enter the 6-digit verification code sent to{" "}
              <span className={signupStyles.bold}>
                {values.email || emailId}
              </span>
            </Grid2>
            <Grid2>
              <Box className={signupStyles.verificationContainer}>
                {Array.from({ length: 6 }).map((_, index) => (
                  <input
                    key={index}
                    type="text"
                    maxLength={1}
                    value={enteredCode[index] || ""}
                    onChange={(e) => {
                      const value = e.target.value.replace(/\D/g, "");
                      handleCodeChange(index, value);
                    }}
                    onKeyDown={(e) => handleCodeKeyDown(index, e)}
                    onPaste={handlePaste}
                    ref={(el) => (inputRefs.current[index] = el)}
                    className={signupStyles.verificationInput}
                  />
                ))}
              </Box>
              <Grid2 className={signupStyles.error}>{error}</Grid2>
            </Grid2>
            <Grid2 className={signupStyles.receiveCode}>
              Didn’t receive the code?
              <span
                className={signupStyles?.resend}
                onClick={() => resendOtp()}
              >
                Resend Verification Code
              </span>
            </Grid2>
          </>
        )}

        <Grid2 className={signupStyles.CreateAccount} onClick={submitHandler}>
          {loading ? (
            <CircularProgress size={25} color="inherit" />
          ) : activeStep === 2 ? (
            "Verify and Create Account"
          ) : activeStep === 1 ? (
            "Next Step"
          ) : (
            "Continue"
          )}
        </Grid2>

        {activeStep === 1 && (
          <span className={signupStyles.Back} onClick={handleBack}>
            Back
          </span>
        )}

        {activeStep === 0 && (
          <>
            <Grid2 className={signupStyles.footerText}>
              <Grid2>Already have an account?</Grid2>
              <Grid2
                className={signupStyles.Signin}
                onClick={() => navigate("/login")}
              >
                Sign In
              </Grid2>
            </Grid2>
          </>
        )}
      </Grid2>
    </>
  );
}
